{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "전체 옵션 보기",
  "Spoiler_Reveal_Tooltip": "클릭 및 표시하기",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "트윗하기",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "아이템 목록 축소됨",
  "Spoiler_Reveal_Video_CTA": "동영상 표시",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "이미지 확대",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "전체 결과 보기",
  "Spoiler_Reveal_Image_Placeholder": "이미지에 스포일러가 포함되어 있습니다.",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "탐색 슬라이더",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "1개 이상의 답변에 투표할 수 있습니다.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "오디오 제어 도구 더보기",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "닫기",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "{{fileType}} 불러오는 중",
  "Polls_Plugin_User_Avatar_Alt": "사용자 아바타",
  "Preview_ReadMore_Label": "더보기",
  "Spoiler_Insert_Tooltip": "스포일러",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "사용 횟수",
  "Spoiler_Reveal_Gallery_Placeholder": "갤러리에 스포일러가 포함되어 있습니다.",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "예약하기",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "활동 제한 해제",
  "Spoiler_Reveal_Gallery_CTA": "갤러리 표시",
  "Poll_Viewer_ShowLess_CTA": "닫기",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "활동 제한",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}}명의 익명",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "팔로우",
  "VerticalEmbed_Products_Button": "구매하기",
  "Poll_Viewer_Toast_Error_ServerDown": "서버에 연결할 수 없습니다. 잠시 후에 다시 시도해보세요.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "응답자 {{count}}명",
  "Poll_Viewer_VoteCount": "{{number}}표",
  "VerticalEmbed_Events_Button": "등록하기",
  "Spoiler_Reveal_Image_CTA": "이미지 표시",
  "Poll_Viewer_Toast_Error_Connection": "인터넷 연결 상태를 확인하세요.  ",
  "Poll_Viewer_Visibility_Owner_Footer": "결과는 본인에게만 확인할 수 있습니다.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "해당 답변에 응답한 이용자는 {{count}}명입니다.",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "아이템 목록 확장됨",
  "Audio_Plugin_Cover_Alt": "오디오 커버",
  "Spoiler_Reveal_Video_Placeholder": "동영상에 스포일러가 포함되어 있습니다.",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "전체 게시물 보기",
  "UploadFile_Viewer_Download": "{{fileType}} 다운로드",
  "VerticalEmbed_Units_Hour": "{{hours}}시간",
  "VerticalEmbed_Units_Minute": "{{minutes}}분",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
